module.exports = __webpack_public_path__ + "static/media/construction.be7ca6d6.png";